import { BriefingView } from "../components/BriefingView";
import { EmptyState } from "../components/ui/EmptyState";
import { ErrorState } from "../components/ui/ErrorState";
import { InboxIcon } from "../components/ui/icons";
import { SkeletonScreen } from "../components/ui/Skeleton";
import { ApiRequestError } from "../api/client";
import { common, today } from "../copy/sq";
import { useLatestBriefing } from "../hooks/useApi";

export function TodayScreen() {
  const { data, isLoading, isError, error, refetch, isFetching } = useLatestBriefing();

  if (isLoading) return <SkeletonScreen cards={5} />;

  if (isError) {
    const notFound = error instanceof ApiRequestError && error.status === 404;
    if (notFound) {
      return (
        <EmptyState
          icon={<InboxIcon width={32} height={32} />}
          title={today.emptyTitle}
          description={today.emptyDescription}
        />
      );
    }
    return (
      <ErrorState
        title={today.errorTitle}
        message={error instanceof Error ? error.message : undefined}
        onRetry={() => refetch()}
      />
    );
  }

  if (!data) return null;

  return (
    <div>
      {isFetching ? <p className="mb-3 text-xs text-ink-400">{common.refreshing}</p> : null}
      <BriefingView briefing={data} />
    </div>
  );
}
